import React from 'react';
import PropTypes from 'prop-types'

const NotAllowed = ({ match }) => (
  <div>
    <h3>Not allowed</h3>
    <p>Not allowed to view: '{match.url}'</p>
  </div>
)

NotAllowed.propTypes = {
  match: PropTypes.object.isRequired,
}

export default NotAllowed;



// WEBPACK FOOTER //
// ./src/containers/NotAllowed/index.jsx